module.exports = __webpack_public_path__ + "static/media/slider-img2.3c37ef7c.jpg";